import { render, staticRenderFns } from "./form-element.vue?vue&type=template&id=46e939d8&"
import script from "./form-element.vue?vue&type=script&lang=ts&"
export * from "./form-element.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports